/**
 * 点状分布图层
 * Created by 1 on 2016/12/14.
 */
'use strict';
/**
 * 点状分布图层
 * @module PointLayer
 */
define([
    './DistributeLayer',
    '../utils/CommonUtil',
    '../utils/GeometryUtil',
    '../misc/DistanceGrid',
    '../utils/LoggerUtil',
    '../g2'
],function(
    DistributeLayer,
    CommonUtil,
    GeometryUtil,
    DistanceGrid,
    LoggerUtil,
    g2
){
    /**
     * 构造方法
     * @constructor
     * @classdesc 点图层
     * @augments G.lys.DistributeLayer
     * @alias G.lys.PointLayer
     * @param {Object} options - 必填，构造参数；
     * @param {G.Map/g2.carto.Map} options.map -必填，地图对象
     * @param {String} options.layerId - 可选，图层id，默认为随机字符串
     * @param {String} options.idKey - 必填，数据记录中作为唯一标识的字段名
     * @param {String} options.attributeField - 可选，数据记录中属性信息挂接的属性名，默认为空
     * @param {String} options.geometryField - 可选，数据记录中空间属性名，默认为空，如果有值，则几何使用数据记录中对应的坐标信息；
     * @param {String} options.xField - 可选，数据记录中x坐标字段名，默认为LONGITUDE
     * @param {String} options.yField - 可选，数据记录中y坐标字段名，默认为LATITUDE
     * @param {Object} options.symbolConfig - 必填，符号配置
     * @param {String} options.defaultSymbolKey - 可选，符号配置文件中默认符号的key值，默认为default
     * @param {Number} options.spatialReference - 可选，图层坐标系，默认4326
     * @param {Number} options.dataSpatialReference - 可选，叠加数据的坐标系，默认图层坐标系
     * @param {Function} options.symbolUpdateCallback - 可选，地图显示的符号更新时的回调，
     * @param {Object} options.callbackContext - 可选，回调的上下文
     * @returns {Class} - 实例化的对象
     */
    var layer=DistributeLayer.extend({
        options:{
            //默认配置
            symbolConfig:false,
            //经度字段名
            xField:'LONGITUDE',
            //纬度字段名
            yField:'LATITUDE'
        },
        initialize:function(options){
            //
            DistributeLayer.prototype.initialize.call(this,options);
            //没有坐标的数据
            this.noneSpatialArr=[];
            //显示的元素
            this.elements=[];
            //当前级别
            this.currentZoom=this.map.getZoomLevel();
        },
        /**
         * 添加监听
         * @private
         */
        _addListeners:function(){
            //do parent first
            DistributeLayer.prototype._addListeners.call(this);
            //
            this.map.listen('extentchanged',this._extentChangeListener,this);
        },
        /**
         * 移除监听
         * @private
         */
        _removeListeners:function(){
            this.map.off('extentchanged',this._extentChangeListener,this);
            //do parent last
            DistributeLayer.prototype._removeListeners.call(this);
        },
        _extentChangeListener:function(){
            var currentZoom=this.map.getZoomLevel();
            //更新符号
            this.updateSymbol(currentZoom);
            //
            this.currentZoom=currentZoom;
        },
        /***
         * 地图点击
         * @returns {layer._mapMouseMoveListener|*}
         * @private
         */
        _mapClickListener:function(event){
            var dEle=this.hitTest(event.screenX, event.screenY);
            if(dEle){
                this.fire('click',{
                    element:dEle.element,
                    layer:dEle.layer
                });
            }
        },
        /**
         * 批量添加点
         * @method
         * @memberOf G.lys.PointLayer.prototype
         * @param {Array} dataArr - 必填，数据数组
         * @param {Object} options - 可选
         * @param {Number} options.dataSpatialReference -可选，数据的坐标系，默认为图层的坐标系
         */
        addElements:function(dataArr,options){
            if(!CommonUtil.isArray(dataArr)){
                LoggerUtil.error('dataArr is not an array');
                return ;
            }
            options=options||{};
            //
            var zoom=this.map.getZoomLevel();
            //坐标不正确的数据
            var spatialReference=this.options.spatialReference,
                dataSpatialReference=options.dataSpatialReference||
                    this.options.dataSpatialReference;
            //遍历数据
            for(var i=0,len=dataArr.length;i<len;i++){
                var data=dataArr[i];
                //获取坐标
                var point=this._getGeometry(data,dataSpatialReference,spatialReference);
                //坐标无效，记录无效数据；
                if(!this.validateGeometry(point)){
                    this.noneSpatialArr.push(data);
                    continue;
                }
                //根据数据和比例尺获取符号
                var symbolObj=this._getSymbol(data,zoom),
                    elementId=this._getRecordId(data);
                var ele = new g2.sfs.Element({
                    id:elementId,
                    geometry: point,
                    symbol: symbolObj.symbol
                });
                //保存数据
                ele._data=data;
                //当前符号的比例尺级别范围；
                ele._zoomRange=symbolObj.zoomRange;
                //保存当前符号的symbolkey
                ele._symbolKey=symbolObj.symbolKey;
                //保存添加的元素
                this.elements.push(ele);
                //添加到图层
                this.layer.add(ele);
                //test position
                // var testSym = new g2.sfs.SimpleMarkerSymbol({
                //         fillColor: new g2.sfs.Color({a: 255, r: 255, g:0, b: 0}),
                //         size: 2
                //     }
                // );
                // var testEl = new g2.sfs.Element({geometry: point, symbol: testSym});
                // this.layer.add(testEl);
            }
            //notify symbol updated
            this._onSymbolsUpdated();
            //notify elements changed
            this._onElementChanged();
        },
        /**
         * 移除要素
         * @method
         * @memberOf G.lys.PointLayer.prototype
         * @param {Array} elementArr - 必填，元素数组
         */
        removeElements:function(elementArr){
            if(CommonUtil.isArray(elementArr)){
                for(var i=elementArr.length-1;i>=0;i--){
                    var ele=elementArr[i];
                    this.layer.remove(ele);
                }
                //notify symbol updated
                this._onSymbolsUpdated();
                //notify elements changed
                this._onElementChanged();
            }
        },
        /**
         * 地图点击事件
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         * @param {Number} screenX - 必填，元素的id
         * @param {Number} screenY - 必填，元素的id
         * @returns {Function}
         */
        hitTest:function(screenX, screenY){
            var hitList=[];
            var ele=this.layer.hitTest(screenX, screenY);
            if(ele){
                hitList.push(ele);
            }
            return hitList[0]||null;
        },
        /**
         * 控制显影
         * @method
         * @memberOf G.lys.PointLayer.prototype
         * @param {Boolean} visible - 必填，是否可见
         */
        setVisible:function(visible){
            this.layer.setVisible(visible||false);
            //更新图例
            if(visible){
                this.invokeCallback('symbolUpdateCallback',{
                    layerId:this.options.layerId,
                    symbols:this.currentSymbols
                });
            }else{
                this.invokeCallback('symbolUpdateCallback',{
                    layerId:this.options.layerId,
                    symbols:[]
                });
            }
        },
        /**
         * 清空图层
         * @method
         * @memberOf G.lys.PointLayer.prototype
         */
        clear:function(){
            this.elements=[];
            //
            DistributeLayer.prototype.clear.call(this);
        },
        /**
         * 销毁方法
         * @method
         * @memberOf G.lys.PointLayer.prototype
         */
        destroy:function(){
            DistributeLayer.prototype.destroy.call(this);
        }
    });
    /**
     * 定义图层类型
     */
    Object.defineProperty(layer,'type',{
        value:11,
        configurable:false,
        writable:false
    });
    return layer;
});
